import { render } from "./giftVoucherRecipientForm.vue?vue&type=template&id=17f73507&scoped=true"
import script from "./giftVoucherRecipientForm.vue?vue&type=script&lang=js"
export * from "./giftVoucherRecipientForm.vue?vue&type=script&lang=js"

import "./giftVoucherRecipientForm.vue?vue&type=style&index=0&id=17f73507&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f73507"]])

export default __exports__